<template>
  <div class="reports-index">
    <el-form class="search-filter">
      <div class="filter-worker">
        <date-picker
          :editable="false"
          ref="datePicker"
          placeholder="Фильтр по дате"
          range
          v-model="filter.datetimeRange"
          @change="changeFiled"
        ></date-picker>
      </div>
      <div class="filter-worker">
        <filter-select
          v-model="filter.users"
          label="Выберите пользователя"
          hideLabel
          @input="changeFiled"
          :options="filterCollection.users"
        />
        <!--        <el-select-->
        <!--          v-model="filter.users"-->
        <!--          @change="changeFiled"-->
        <!--          placeholder="Выберите пользователя"-->
        <!--        >-->
        <!--          <el-option-->
        <!--            v-for="item in filterCollection.users"-->
        <!--            :key="item.uid"-->
        <!--            :label="item.company || item.email"-->
        <!--            :value="item.uid"-->
        <!--          >-->
        <!--          </el-option>-->
        <!--        </el-select>-->
      </div>
      <div class="filter-worker">
        <filter-select
          v-model="filter.object"
          label="Выберите обьект"
          hideLabel
          @input="changeFiled"
          :options="filterCollection.objects"
        />

        <!--        <el-select-->
        <!--          v-model="filter.object"-->
        <!--          @change="changeFiled"-->
        <!--          placeholder="Выберите обьект"-->
        <!--        >-->
        <!--          <el-option-->
        <!--            v-for="item in filterCollection.objects"-->
        <!--            :key="item.id"-->
        <!--            :label="item.name"-->
        <!--            :value="item.id"-->
        <!--          >-->
        <!--          </el-option>-->
        <!--        </el-select>-->
      </div>
    </el-form>
    <h1 v-if="empty">По выбраному фильтру ничего не найдено</h1>
    <dl class="info-block" v-if="!empty">
      <div class="analytics-views" v-loading="loader">
        <div v-for="row in analytics" class="analytic-row">
          <strong class="title">{{ row.name }}, {{ row.unit }}<small v-if="row.error">{{ row.error }}</small></strong>

          <div class="analytics-info">
            <div>
              <span class="name">План/Факт</span>
              <strong>{{ (row.plan).toFixed(2) }}/{{ (row.value).toFixed(2) }}</strong>
            </div>

            <div>
              <span class="name">+/-</span>
              <strong>{{ (row.value - row.plan).toFixed(2) }}</strong>
            </div>

            <div>
              <span class="name">%</span>
              <strong v-if="row.plan !== 0">{{ (row.value * 100 / row.plan).toFixed(1) }}</strong>
            </div>
          </div>
        </div>
      </div>

    </dl>
  </div>
</template>


<script>
import firebase from 'firebase'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import FilterSelect from '../../../components/FilterSelect'
import {formatEndDate, formatStartDate} from "../../../utils/date";

export default {
  name: 'Welding',
  components: {DatePicker, FilterSelect},
  data () {
    return {
      loader: false,
      analytics: [],
      empty: false,
      shortcuts: [
        {
          text: 'День',
          onClick () {
            const dateNow = new Date()
            const dateLast = new Date(dateNow.getTime() - 24 * 60 * 60 * 1000)
            return [dateLast, dateNow]
          },
        },
        {
          text: 'Неделя',
          onClick () {
            const dateNow = new Date()
            const dateLast = new Date(dateNow.getTime() - 7 * 24 * 60 * 60 * 1000)
            return [dateLast, dateNow]
          },
        },
        {
          text: 'Месяц',
          onClick () {
            const dateNow = new Date()
            const dateLast = new Date(dateNow.getTime() - 31 * 24 * 60 * 60 * 1000)
            return [dateLast, dateNow]
          },
        },
        {
          text: 'За все время',
          onClick () {
            return []
          },
        },
      ],
      filter: {
        users: null,
        object: null,
        typeJob: null,
        datetimeRange: [],
      },
      filterCollection: {
        users: [],
        objects: [],
      },
      projectWorksType: {},
      workTypeMap: {},
      prepareJobs: {},
      mapJobs: {}
    }
  },
  mounted () {
    if (this.$store.state.project.disableDate) {
      this.filter.datetimeRange = [new Date('2021-08-24'), new Date('2021-09-02')];
    }

    const defaultQuery = myFirestore
      .collection('projects')
      .doc(this.$store.state.project.id)
      .collection('reports')
      .where('type', '==', 'WILD_PIPE')

    this.loader = true
    const promiseUser = this.fetchUsers(defaultQuery)
    const promiseObject = this.getMapData().then(map => {
      const tmp = Object.entries({...map}).map(([key, value]) => {
        return {
          value: key,
          label: value.name,
        }
      }).sort((a, b) =>{
        const fa = a.value.toLowerCase();
        const fb = b.value.toLowerCase();

        if (fa > fb) {
          return -1;
        }
        if (fa < fb) {
          return 1;
        }
        return 0;
      });

      this.filterCollection.objects = [{
        value: null,
        label: 'Все Линии',
      }, ...tmp]
    })
    Promise.all([promiseUser, promiseObject])
      .then(() => this.changeFiled())
      .then(() => this.loader = false)
  },
  methods: {
    fetchUsers (defaultQuery) {
      const loadUserFromDirectory = (id) => {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('users')
          .doc(id)
          .get().then(r => r.data())
      }
      const usersArray = []
      return defaultQuery
        .get().then((response) => {
          response.forEach((sub) => {

            const data = sub.data()
            usersArray.push(data.user)
          })

          return Promise.all(
            usersArray.map(i => loadUserFromDirectory(i.user_profile_id).then((r) => r || i))
          )

        }).then((usersArray) => {
          const users = Object.values(usersArray.reduce((acum, item) => (acum[item.uid] = item, acum), {}))
          const resultList = users.reduce((acum, i) => {
            const name = i.company || i.name || i.email
            acum[name] = acum[name] || []
            acum[name].push(i.uid)
            return acum
          }, {})
          const resultUser = Object.entries(resultList).map(([key, val]) => ({
            uid: val.join(','),
            company: key,
          }))
          resultUser.unshift({
            uid: null,
            company: 'Все исполнители',
          })

          this.filterCollection.users = resultUser.map((item) => ({
            value: item.uid,
            label: item.company || item.email,
          }))
        })
    },
    getMapData () {
      if (Object.keys(this.workTypeMap).length > 0) {
        return Promise.resolve(this.workTypeMap)

      }
      return myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('works_type')
        .get()
        .then((response) => {
          const result = []
          response.forEach(sub => {
            const tmp = {
              _id: sub.id,
              ...sub.data()
            }
            result.push(tmp)
          })

          const tmp = result
            .filter(i => i.type === 'line')
            .reduce((acum, item) => {
              const stat = (item.joints || [])
                .reduce((a, i) => {
                  a.inc += parseFloat(i.inc, 10)
                  a.joint++;
                  a.jointName[i.id] = true
                  return a
                }, {joint: 0, inc: 0, jointName: {}})
              acum[item._id] = {
                name: item.id,
                ...stat,
              }
              return acum
            }, {})
          this.workTypeMap = tmp
          return this.workTypeMap
        })
    },
    changeFiled () {
      let query = myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports')
        .where('type', '==', 'WILD_PIPE')

      if (this.filter.datetimeRange[0] && this.filter.datetimeRange[1]) {

        const endDate = this.filter.datetimeRange[1]
        const startDate = this.filter.datetimeRange[0]

        query = query.where('dateunix', '>=', formatStartDate(startDate))
        query = query.where('dateunix', '<=', formatEndDate(endDate))
      }

      if (this.filter.users && this.filter.users.value) {
        query = query.where('user.uid', 'in', this.filter.users.value.split(','))
      }

      return this.getMapData().then((map) => {
        return query.get().then((response) => {
          const tmp = []
          response.forEach((sub) => {

            const data = sub.data()
            tmp.push(...data.joints.map(i => {
              i['line'] = data.line.value;
              return i;
            }))
          })
          const factStats = tmp.reduce((acum, item) => {
            const line = item.line
            const stat = (item.id_joint || [])
              .filter(item => map[line] && map[line].jointName[item.id])
              .reduce((a, i) => {
                if (a[line]) {
                  a[line].inc += parseFloat(i.inc, 10)
                  a[line].joint++
                } else {
                  a[line] = {}
                  a[line].inc = parseFloat(i.inc, 10)
                  a[line].joint = 1
                }

                return a
              }, acum)

            return stat
          }, {})

          const factArray = Object.values(factStats)
          const planArray = Object.values(map)
          if (this.filter.object && this.filter.object.value) {
            factArray.length = 0
            planArray.length = 0
            if (factStats[this.filter.object.value]) {
              factArray.push(factStats[this.filter.object.value])
            } else {
              factArray.push({inc: 0})
            }

            planArray.push(map[this.filter.object.value])
          }
          const resultSum = [{
            name: 'Дюймы',
            plan: planArray.reduce((acum, i) => (acum += i.inc, acum), 0),
            fact: factArray.reduce((acum, i) => (acum += (i.inc || 0), acum), 0)
          }, {
            name: 'Стыки',
            plan: planArray.reduce((acum, i) => (acum += i.joint, acum), 0),
            fact: factArray.reduce((acum, i) => (acum += (i.joint || 0), acum), 0)
          }]

          this.analytics.length = 0
          this.analytics = resultSum.map((val) => ({
            name: val.name,
            plan: val.plan ? val.plan : 0,
            value: val.fact ? val.fact : 0,
            unit: val.unit,
            index: val.index,
            error: (!val.plan && val.plan !== 0) ? 'Нет плана' : false
          }))
        })
      })
    }
  }
}
</script>


<style scoped lang="scss">

.reports-index {
  margin: 0 auto;
  max-width: 1024px;
  padding-top: 20px;
}

.search-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media screen and (max-width: 764px) {
  .search-filter {
    flex-direction: column;

    .filter {
      width: 100%;
    }
  }

  .filter-btn {
    width: 100%;
    margin-left: 0 !important;

    button {
      width: 100%;
    }
  }
  .reports-index {
    padding: 0 10px;
  }

  .search-filter .input-search {
    margin-right: 0;
  }

  .filter-worker {
    width: 100%;

    .el-select {
      width: 100%;
    }
  }
}

.filter-worker {
  min-width: 200px;
  margin-top: 10px;
  height: 48px;
  margin-right: 5px;
}

.chart-div {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;

  div {
    width: 500px !important;
    order: 0;
    flex: 0 1 auto;
    align-self: auto;
  }
}

.info-block {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

dl {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

dt {
  display: flex;
  flex-direction: column;
  flex: 1 0 50%;
  text-align: right;
  box-sizing: border-box;
  padding-right: 10px;
  font-weight: bold;
  margin: 0px;
}

dd {
  display: flex;
  flex-direction: column;
  flex: 1 0 50%;
  text-align: left;
  box-sizing: border-box;
  padding-left: 10px;
  margin: 0px;
}

> > > .mx-datepicker-range {
  width: 100%;

  .mx-input {
    border: 1px solid #DCDFE6;
    height: 40px;
  }
}

> > > .el-table__body {
  .cell {
    font-weight: 600;
  }
}

.analytics-views {
  max-width: 428px;
  width: calc(100% - 40px);
  margin: 10px auto 22px auto;
  padding-top: 0px;
}

.analytic-row {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  border-bottom: 1px solid #ccc;
  padding-bottom: 10px;
  margin-top: 15px;
  flex-direction: column;

  .title {
    margin-bottom: 4px;
  }

  .name {
    margin-right: 8px;
  }
}

.analytics-info {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 4px;
  padding-top: 0;
  flex: 1;

  div {
    text-align: left;
  }

  .name {
    color: #3a8ee6;
    font-weight: 600;
    margin-right: 10px;

    &:last-child {
      margin-right: 0;
    }
  }
}

@media screen and (max-width: 764px) {
  .analytics-info {
    flex-direction: column;

    div {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Analytics/Welding.vue